// extracted by mini-css-extract-plugin
export var logo = "navbarDesktop-module--logo--0b951";
export var wrapper = "navbarDesktop-module--wrapper--7ae09";